import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import './Onboarding.css';

export const Onboarding = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Navigate to login after 2 seconds
        const timer = setTimeout(() => {
            navigate('/login');
        }, 2000);

        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div className="onboarding-wrapper">
            <div className="onboarding-logo-container">
                <div className="onboarding-logo">
                    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="60" cy="60" r="60" fill="black"/>
                        <circle cx="45" cy="50" r="8" fill="white"/>
                        <circle cx="75" cy="50" r="8" fill="white"/>
                        <path d="M 40 70 Q 60 85 80 70" stroke="white" strokeWidth="4" fill="none"/>
                    </svg>
                </div>
                <div className="onboarding-brand-text">모이</div>
            </div>
            <div className="onboarding-loading">
                <div className="loading-spinner"></div>
            </div>
        </div>
    );
};
